import styles from './index.less';
import UserAccount from './components/UserAccount';
import BillInfo from '@/pages/PaymentBill/components/BillInfo';
import BillFooter from '@/pages/PaymentBill/components/BillFooter';
import { useState } from 'react';
import { useModel, history } from '@umijs/max';
import PaymentInfo from '@/pages/PaymentBill/components/PaymentInfo';
import { Toast } from 'react-vant';
import { queryPayment } from '@/pages/PaymentBill/service';
import CustomerDefaultInformation from '@/components/CustomerDefaultInformation';
import { Arrow } from '@react-vant/icons';
import { wechatPayRequestEnum } from '@/pages/Payment/interface';

const PaymentBill = () => {
  const { refreshAccount } = useModel('useAccount', (model) => ({
    refreshAccount: model.refreshAccount,
  }));

  const [allAmount, setAllAmount] = useState<string>('0');
  const [paymentInfoVisible, setPaymentInfoVisible] = useState<boolean>(false);
  const [paymentInfoText, setPaymentInfoText] = useState<string>('缴费');
  const [discountAmount, setDiscountAmount] = useState<number>(0); // 优惠金额
  const [refresh, setRefresh] = useState<boolean>(false);
  const [paymentBillData, setPaymentBillData] = useState<any>();

  const openPaymentInfo = () => {
    setPaymentInfoVisible(true);
    setPaymentInfoText('支付');
  };

  const handleWechatPay = (data: any) => {
    if (typeof window.WeixinJSBridge !== undefined) {
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: data?.appId,
          timeStamp: data?.timeStamp,
          nonceStr: data?.nonceStr,
          package: data?.package,
          signType: data?.signType,
          paySign: data?.paySign,
        },
        function (res: any) {
          console.log(res, 'res');
          if (res.err_msg === wechatPayRequestEnum.success) {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            setRefresh(true); // 成功后刷新账单
            refreshAccount(); // 成功后重新获取账户余额信息
          } else if (res.err_msg === wechatPayRequestEnum.cancel) {
            Toast.fail('用户取消了支付');
          } else {
            Toast.fail('支付失败');
          }
        },
      );
    } else {
      Toast.fail('请在微信公众号内打开');
    }
  };

  const onPay = () => {
    if (paymentBillData.billNos.length !== 0) {
      queryPayment({
        paymentAmount: paymentBillData.paymentAmount,
        billNos: paymentBillData.billNos,
        customerId: paymentBillData.customerId,
        billDeductionAmount: paymentBillData.billDeductionAmount,
        totalAmount: paymentBillData.totalAmount,
        isDeduction: paymentBillData.isDeduction,
        balanceDeduction: paymentBillData.balanceDeduction,
        payableAmount: paymentBillData.payableAmount,
        discountAmount: paymentBillData.discountAmount,
        penaltyAmount: paymentBillData.penaltyAmount,
        surplusAmount: paymentBillData.surplusAmount,
        surplusMethod: paymentBillData.surplusMethod,
        returnAmount: paymentBillData.returnAmount,
        paymentChannels: [
          {
            payChannel: '微信',
            amount: paymentBillData.totalAmount,
          },
        ],
      }).then((res) => {
        if (res?.code === 200) {
          handleWechatPay(res?.data?.result);
        }
      });
    } else {
      Toast.fail('请选择账单');
    }
  };

  const jumpToPaymentRecord = () => {
    history.push('/payment/record');
  };

  return (
    <div className={styles.container}>
      <CustomerDefaultInformation />
      <UserAccount />
      <div onClick={jumpToPaymentRecord} className={styles.historyContainer}>
        <p>历史账单：</p>
        <Arrow />
      </div>
      <BillInfo
        getAllAmount={setAllAmount}
        refresh={refresh}
        getDiscountAmount={setDiscountAmount}
        getPaymentBillData={setPaymentBillData}
      />
      <PaymentInfo
        visible={paymentInfoVisible}
        paymentAmount={allAmount}
        close={setPaymentInfoVisible}
        discountAmount={discountAmount}
      />
      <BillFooter
        allAmount={allAmount?.toString() || '0'}
        btnText={paymentInfoText}
        btnClick={openPaymentInfo}
        paymentInfoVisible={paymentInfoVisible}
        onPay={onPay}
      />
    </div>
  );
};

export default PaymentBill;
